/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { setIsSaving } from 'owa-options-store';
import saveOrDiscardOptions from '../utils/saveOrDiscardOptions';

export const saveOptions = orchestratorAction('saveOptions', async function saveOptions() {
    try {
        setIsSaving(true);
        await saveOrDiscardOptions(true);
    } finally {
        setIsSaving(false);
    }
});
